<div class="progress">
    <div class="progress-bar progress-bar-striped bg-info" role="progressbar" [ngStyle]="{'width':regPct + '%'}"
        aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
    <div class="progress-bar progress-bar-striped" role="progressbar" [ngStyle]="{'width':gamePct + '%'}"
        aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
    <div class="progress-bar progress-bar-striped bg-success" role="progressbar"
        [ngStyle]="{'width':resultPct + '%'}" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
</div>